import React from 'react'

import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
    root: {
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    griditem: {
        textAlign: 'center',
    },
}));

function Spinner() {
    const classes = useStyles();

    return (
        <Grid container className={classes.root}>
            <Grid item className={classes.griditem}>
                <CircularProgress />
            </Grid>
        </Grid>
    );
}

export default Spinner;